var _style, _g, _g2, _g3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStraight01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st209{fill:#FFFFFF;stroke:#010101;stroke-width:3;stroke-miterlimit:10;}\n\t.st208{fill:#FFFFFF;}\n\t.st207{fill:none;stroke:#010101;stroke-width:3;stroke-miterlimit:10;}\n\t.st206{fill:#010101;}\n\t.st205{fill:#FFFFFF;stroke:#010101;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M206.57,123.1v0.04c-0.17,0.07-0.34,0.14-0.52,0.21L206.57,123.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st208",
    d: "M116.83,126.54c-5.06,2.15-7.22,7.95-4.8,12.89c0,0,1.75,3.56,2.6,7.02c2.63,10.73,11.58,73.1,11.58,73.1 c0.78,5.44,2.66,9.95,4.18,10.02c1.52,0.07,4.26,3.96,6.28,7.34c0,0,0,0,1.72,6.13c2.41,8.58,1.59,14.93,1.24,20.4 c-0.98,15.03,0.95,19.03,0.99,33.38c0.05,18.86-10.39,107.4-10.39,107.4c-0.64,5.46,3.27,10.67,8.69,11.57l63.23,10.95 c5.43,0.9,9.83-2.86,9.78-8.36l0.17-284.26c-0.05-5.5-0.59-10.2-1.2-10.45s-2.18-0.6-2.18-0.24s-4.33-0.58-9.62-2.08l-14.59-7.92 c-3.65-4.11-6.83-7.9-7.05-8.42s-0.59-1.73-0.59-2.55s-4.14,0.26-9.2,2.41L116.83,126.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M116.83,126.54c-5.06,2.15-7.22,7.95-4.8,12.89c0,0,1.75,3.56,2.6,7.02c2.63,10.73,11.58,73.1,11.58,73.1 c0.78,5.44,2.66,9.95,4.18,10.02c1.52,0.07,4.26,3.96,6.28,7.34c0,0,0,0,1.72,6.13c2.41,8.58,1.59,14.93,1.24,20.4 c-0.98,15.03,0.95,19.03,0.99,33.38c0.05,18.86-10.39,107.4-10.39,107.4c-0.64,5.46,3.27,10.67,8.69,11.57l63.23,10.95 c5.43,0.9,9.83-2.86,9.78-8.36l0.17-284.26c-0.05-5.5-0.59-10.2-1.2-10.45s-2.18-0.6-2.18-0.24s-4.33-0.58-9.62-2.08l-14.59-7.92 c-3.65-4.11-6.83-7.9-7.05-8.42s-0.59-1.73-0.59-2.55s-4.14,0.26-9.2,2.41L116.83,126.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st208",
    d: "M300.31,126.54c5.06,2.15,7.22,7.95,4.8,12.89c0,0-1.75,3.56-2.6,7.02c-2.63,10.73-11.58,73.1-11.58,73.1 c-0.78,5.44-2.66,9.95-4.18,10.02c-1.52,0.07-4.26,3.96-6.28,7.34c0,0,0,0-1.72,6.13c-2.41,8.58-1.59,14.93-1.24,20.4 c0.98,15.03-0.95,19.03-0.99,33.38c-0.05,18.86,10.39,107.4,10.39,107.4c0.64,5.46-3.27,10.67-8.69,11.57l-63.23,10.95 c-5.43,0.9-9.83-2.86-9.78-8.36l-0.17-284.26c0.05-5.5,0.59-10.2,1.2-10.45s2.18-0.6,2.18-0.24s4.33-0.58,9.62-2.08l14.59-7.92 c3.65-4.11,6.83-7.9,7.05-8.42c0.23-0.52,0.59-1.73,0.59-2.55s4.14,0.26,9.2,2.41L300.31,126.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M300.31,126.54c5.06,2.15,7.22,7.95,4.8,12.89c0,0-1.75,3.56-2.6,7.02c-2.63,10.73-11.58,73.1-11.58,73.1 c-0.78,5.44-2.66,9.95-4.18,10.02c-1.52,0.07-4.26,3.96-6.28,7.34c0,0,0,0-1.72,6.13c-2.41,8.58-1.59,14.93-1.24,20.4 c0.98,15.03-0.95,19.03-0.99,33.38c-0.05,18.86,10.39,107.4,10.39,107.4c0.64,5.46-3.27,10.67-8.69,11.57l-63.23,10.95 c-5.43,0.9-9.83-2.86-9.78-8.36l-0.17-284.26c0.05-5.5,0.59-10.2,1.2-10.45s2.18-0.6,2.18-0.24s4.33-0.58,9.62-2.08l14.59-7.92 c3.65-4.11,6.83-7.9,7.05-8.42c0.23-0.52,0.59-1.73,0.59-2.55s4.14,0.26,9.2,2.41L300.31,126.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M176.87,97.96l-1,2c0.04,0.19-0.05,0.81,0,1c2.93,14.03,16.77,21.63,31.85,22.13v-12.81 C196,109.9,184.29,103.4,179,93.96C177.87,94.96,177.87,95.96,176.87,97.96z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M240.72,97.96l1,2c-0.04,0.19,0.05,0.81,0,1c-2.93,14.03-16.77,21.63-31.85,22.13v-12.81 c11.72-0.38,23.43-6.88,28.72-16.32C239.72,94.96,239.72,95.96,240.72,97.96z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st208",
    d: "M89.62,404.46c0.11,5.5,4.7,10,10.2,10h14.66c5.5,0,10-4.5,9.99-10c0,0-0.05-94.73,7.35-152 c0.98-7.58,2.04-15.08,3.17-22.49c0.16-1.06,0.16-1.06,0.16-1.06c0.18-1.17-0.35-6.57-1.17-12.01c0,0-9.42-62.04-12.05-72.77 c-0.85-3.46-3-11.97-6.32-13.71c-0.26-0.14-0.52-0.24-0.79-0.29c-1.94-0.36-1.94-0.36-1.94-0.36c-1.56,2.64-3.61,9.23-4.55,14.65 c0,0-12.1,69.66-15.85,115.37C87.84,316.5,89.62,404.46,89.62,404.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M89.62,404.46c0.11,5.5,4.7,10,10.2,10h14.66c5.5,0,10-4.5,9.99-10c0,0-0.05-94.73,7.35-152 c0.98-7.58,2.04-15.08,3.17-22.49c0.16-1.06,0.16-1.06,0.16-1.06c0.18-1.17-0.35-6.57-1.17-12.01c0,0-9.42-62.04-12.05-72.77 c-0.85-3.46-3-11.97-6.32-13.71c-0.26-0.14-0.52-0.24-0.79-0.29c-1.94-0.36-1.94-0.36-1.94-0.36c-1.56,2.64-3.61,9.23-4.55,14.65 c0,0-12.1,69.66-15.85,115.37C87.84,316.5,89.62,404.46,89.62,404.46z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M211.43,123.1v0.04c0.17,0.07,0.34,0.14,0.52,0.21L211.43,123.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st208",
    d: "M328.38,404.46c-0.11,5.5-4.7,10-10.2,10h-14.66c-5.5,0-10-4.5-9.99-10c0,0,0.05-94.73-7.35-152 c-0.98-7.58-2.04-15.08-3.17-22.49c-0.16-1.06-0.16-1.06-0.16-1.06c-0.18-1.17,0.35-6.57,1.17-12.01c0,0,9.42-62.04,12.05-72.77 c0.85-3.46,3-11.97,6.32-13.71c0.26-0.14,0.52-0.24,0.79-0.29c1.94-0.36,1.94-0.36,1.94-0.36c1.56,2.64,3.61,9.23,4.55,14.65 c0,0,12.1,69.66,15.85,115.37C330.16,316.5,328.38,404.46,328.38,404.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M328.38,404.46c-0.11,5.5-4.7,10-10.2,10h-14.66c-5.5,0-10-4.5-9.99-10c0,0,0.05-94.73-7.35-152 c-0.98-7.58-2.04-15.08-3.17-22.49c-0.16-1.06-0.16-1.06-0.16-1.06c-0.18-1.17,0.35-6.57,1.17-12.01c0,0,9.42-62.04,12.05-72.77 c0.85-3.46,3-11.97,6.32-13.71c0.26-0.14,0.52-0.24,0.79-0.29c1.94-0.36,1.94-0.36,1.94-0.36c1.56,2.64,3.61,9.23,4.55,14.65 c0,0,12.1,69.66,15.85,115.37C330.16,316.5,328.38,404.46,328.38,404.46z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st206",
    cx: 214.54,
    cy: 266.16,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st206",
    cx: 214.54,
    cy: 310.56,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st206",
    cx: 214.54,
    cy: 354.96,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st206",
    cx: 214.54,
    cy: 132.96,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st206",
    cx: 214.54,
    cy: 177.36,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st206",
    cx: 214.54,
    cy: 221.76,
    r: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st205",
    points: "277.75,330.69 277.62,330.7 276.64,311.69 239.3,313.02 239.3,310.58 276.64,309.24  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st205",
    d: "M277.75,333.13l-31.23,2.54c-3.89,0.32-7.22-2.75-7.22-6.65v-16l37.34-1.33l0.98,19.01L277.75,333.13z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st205",
    x1: 254.19,
    y1: 230.03,
    x2: 253.08,
    y2: 309.25
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st205",
    points: "139.3,330.69 139.43,330.7 140.41,311.69 177.75,313.02 177.75,310.58 140.41,309.24  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st205",
    d: "M139.3,333.13l31.23,2.54c3.89,0.32,7.22-2.75,7.22-6.65v-16l-37.34-1.33l-0.98,19.01L139.3,333.13z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st205",
    x1: 162.86,
    y1: 230.03,
    x2: 163.97,
    y2: 309.25
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st205",
    d: "M236.37,172.27c9.7-0.37,28.3-2.39,38-2.76c0,3.63,0,7.26,0,10.89c-12.07,1.19-28.93,2.68-41,3.87 C234.37,179.27,235.37,176.27,236.37,172.27z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStraight01);
export default __webpack_public_path__ + "static/media/STRAIGHT-01.9faf839d8acc868b29e124302450aff7.svg";
export { ForwardRef as ReactComponent };